module.exports = __webpack_public_path__ + "img/teacher2-2.6ba1f3b9.png";